'use strict';

import $ from 'jquery';
import {getPdf} from '../../services/ProductDetailPdfService';
import {saveAs} from 'file-saver';

export default class ProductDetailPdfDownloadLink {
  constructor(el) {
    this.el = el;
    this.$el = $(el);
    this.initialize();
  }

  initialize() {
    this.$el.on('click', this.download.bind(this));
  }

  download(e) {
    // Stop the link from opening, we will specify the action below
    e.preventDefault();

    var $target = $(e.currentTarget);
    var manufacturer = $target.data('manufacturer');
    var partNumber = $target.data('partNumber');

    getPdf(manufacturer, partNumber)
      .then(response => {
        const file = new Blob([response], {type: 'application/pdf'});
        const filename = manufacturer + '_' + partNumber.toString().replace(' ', '') + '.pdf';
        saveAs(file, filename);
      });
  }
}

export function createProductDetailPdfDownload($parent) {
  $parent.find('.productDetailPdfDownload').each((n, el) => new ProductDetailPdfDownloadLink(el));
}



// WEBPACK FOOTER //
// ./assets/js/components/ProductDetailPdfDownload.js